import { getLrs } from 'core/crud/lrs.crud';
import { getSetting } from 'core/crud/systemSettings.crud';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { put, select, takeLatest } from 'redux-saga/effects';
import { actionTypes as actionAuth } from './auth.duck';
import { REDUCER_SYSTEM_SETTINGS } from './conf';

export const actionTypes = {
  GetSystemSettings: 'system/GET_SYSTEM_SETTINGS',
  SetSystemSettings: 'system/SET_SYSTEM_SETTINGS',
  // Añadir action types para LRS
  GetLrs: 'system/GET_LRS',
  SetLrs: 'system/SET_LRS',
};

const initialState = {
  settings: null,
  lrs: {
    // Añadir estado de LRS
    endpoint: null,
    auth: null,
    actor: null,
    loaded: false, // == Flag que controla si se ha cargado los valores del lrs
  },
  loading: false,
};

export const reducer = persistReducer({ storage, key: REDUCER_SYSTEM_SETTINGS }, (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GetSystemSettings:
      return { ...state, loading: true };

    case actionTypes.SetSystemSettings: {
      const { settings } = action.payload;
      if (settings) {
        return { ...state, settings, loading: false };
      }
      return { ...state, loading: false };
    }

    // Añadir casos para LRS
    case actionTypes.GetLrs:
      // No cambiar el estado aquí, dejar que la saga maneje el loading
      return state;

    case actionTypes.SetLrs: {
      const { response } = action.payload;
      if (response && response.data && response.data.status === 'success' && response.data.data) {
        const lrsData = response.data.data;
        return {
          ...state,
          lrs: {
            endpoint: lrsData.endpoint,
            auth: lrsData.auth,
            actor: lrsData.actor,
            loaded: true,
          },
        };
      } else {
        //si no hay datos, poner los valores por defecto
        return {
          ...state,
          lrs: { ...initialState.lrs, loaded: true },
        };
      }
    }

    case actionAuth.Logout: {
      //si logout, borrar estado redux
      return initialState;
    }

    default:
      return state;
  }
});

export const selectors = {
  getSystemSettings: (state) => state[REDUCER_SYSTEM_SETTINGS]?.settings,
  // Añadir selectors para LRS
  getLrs: (state) => {
    const lrs = state[REDUCER_SYSTEM_SETTINGS]?.lrs;
    return lrs
      ? {
          endpoint: lrs.endpoint,
          auth: lrs.auth,
          actor: lrs.actor,
          loaded: lrs.loaded,
        }
      : null;
  },
  isLrsLoaded: (state) => state[REDUCER_SYSTEM_SETTINGS]?.lrs?.loaded || false,
};

export const actions = {
  getSystemSettings: () => ({ type: actionTypes.GetSystemSettings }),
  setSystemSettings: (settings) => ({ type: actionTypes.SetSystemSettings, payload: { settings } }),
  // Añadir actions para LRS
  getLrs: () => {
    return { type: actionTypes.GetLrs };
  },
  setLrs: (response) => ({ type: actionTypes.SetLrs, payload: { response } }),
};

export function* saga() {
  yield takeLatest(actionTypes.GetSystemSettings, function* getSystemSettingsSaga() {
    try {
      // Verificar si ya tenemos los settings en el store
      const existingSettings = yield select(selectors.getSystemSettings);

      if (!existingSettings) {
        // Si no hay datos en el store, hacer la llamada a la API
        const response = yield getSetting();
        yield put(actions.setSystemSettings(response?.data?.data));
      }
    } catch (error) {
      console.error('Error fetching system settings:', error);
    }
  });

  // Añadir saga para LRS
  yield takeLatest(actionTypes.GetLrs, function* getLrsSaga() {
    try {
      const lrs = yield select(selectors.getLrs);
      // Solo hacer la llamada si no se ha hecho antes (loading es false)
      if (!lrs?.loaded) {
        // Marcar como loading antes de hacer la llamada
        yield put({ type: actionTypes.SetLrs, payload: { response: null } });
        const response = yield getLrs();
        yield put(actions.setLrs(response));
      }
    } catch (error) {
      console.error('❌ Error in getLrsSaga:', error);
      yield put(actions.setLrs(null));
    }
  });
}
